import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import PAN from "../../Assets/img/Kyc/Pancard.webp"

const VerifyPANCardSkeleton = () => {
    return (
        <Box sx={{ 
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(1, 1fr)",
            gap: "20px", // space between front and back card
            justifyItems: "center",
            // border: "1px dashed grey",
            // borderRadius: "8px",
            // padding:"10px"
        }}>
            <Typography>Card Preview</Typography>
            <Box sx={{ padding: "16px", border: "1px dashed grey", borderRadius: "8px" }}>
                <img width={"300px"} src={PAN} />
            </Box>
        </Box>
    );
};

export default VerifyPANCardSkeleton;
